module.exports = __webpack_public_path__ + "static/img/ppt-1.3f8b06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt-1.jpg
// module id = Po2S
// module chunks = 1